import React from 'react';
import DailyFeedbackDropdown from '../../UI/DailyFeedbackDropdown/DailyFeedbackDropdown';
import classes from './DailyFeedbackSection.module.css';
import ProgressBar from '../../UI/ProgressBar/ProgressBar';
import { IsListEmpty, IsObjectEmpty, IsStringEmpty } from '../../../utilities/CommonMethods';
import ResourceAPIController from '../../../webServices/ResourceAPIController';
import ShowMiniLoader from '../../../hoc/ShowMiniLoader/ShowMiniLoader';
import StudentResponsePopup from '../../Popups/StudentResponsePopup/StudentResponsePopup';
import FilterIcon from '../../../assets/icons/filter-icon-white.svg';
import FilterDropDown from "../../UI/FilterDropDown/FilterDropDown";
import SortHelper from '../../../utilities/SortHelper';
import { GetFromLocalStorage } from '../../../utilities/CommonMethods';
import Constants from '../../../utilities/Constants';
import DailyFeedbackReportCard from '../../../components/DailyFeedbackReport/DailyFeedbackReport';
class DailyFeedbackSection extends React.PureComponent {

    state = {
        topicsList: [
            {
                id: 0,
                topicName: 'All Topics',
                date: ''
            },
        ],
        activeTopicPos: 0,
        currentTopicId: 0,
        currentUserId: 0,
        feedbackResponses: {
            feedbackAvailable: true,
            subtopics: []
        },
        clearedDoubts: {
            value: 0,
            label: 'Doubt Cleared'
        },
        overallSessionRating: {
            value: '',
            label: 'Overall Session Rating',
            fraction: [0, 0]
        },
        pieChartData: [
            ["Students", "Percentage"],
            ["Completely Understood", 0],
            ["Partially Understood", 0],
            ["Did Not Understand", 0]
        ],
        currentTopicDetails: {
            topicName: 'Loading...',
            date: '',
            responsesReceived: 0,
        },
        studentsList: [],
        fullStudentsList: [],
        feedbackTopicsList: [],
        showTableLoader: true,
        showCardLoader: true,
        showStudentsTable: false,

        showNameFilterDropdown: false,
        nameFilterItems: [{ id: 1, label: 'A -> Z' }, { id: 2, label: 'Z -> A' }],
        activeNameFilterDropDownItem: -1,
        nameSearchFieldValue: '',
        isProgramManager: false,
        feedbackType: ""
    }


    onNameFilterClicked = () => {
        let updatedState = this.state.showNameFilterDropdown;
        this.setState({ showNameFilterDropdown: !updatedState });
    }

    onDropDownItemClicked = (pos) => {
        let updatedList = [...this.state.studentsList];

        // -------- Sort by Name --------
        if (pos === 0) {
            updatedList = SortHelper.sortStudentsByName(updatedList, 'ascending');
        } else {
            updatedList = SortHelper.sortStudentsByName(updatedList, 'descending');
        }
        this.setState({
            studentsList: updatedList,
            activeNameFilterDropDownItem: pos,
            showNameFilterDropdown: false
        })
    }

    nameSearchInputChangeHandler = (event) => {
        let updatedValue = event.target.value;
        this.setState({ nameSearchFieldValue: updatedValue });
    }

    onNameSearchIconClick = (searchString) => {
        const updatedSearchString = searchString.toLowerCase();
        const newList = this.state.fullStudentsList.filter(student => {
            if (student.name.toLowerCase().indexOf(updatedSearchString) !== -1) {
                return true;
            }
        });

        if (!IsListEmpty(newList)) {
            this.setState({ studentsList: newList, showNameFilterDropdown: false, nameSearchFieldValue: searchString, activeNameFilterDropDownItem: -1 });
        } else {
            this.props.onFailureDialogShow('No student found with the matching name.', 'OKAY');
        }

    }

    clearSearchResults = () => {
        const updatedList = [...this.state.fullStudentsList];
        this.setState({ studentsList: updatedList, activeNameFilterDropDownItem: -1, showNameFilterDropdown: false, nameSearchFieldValue: '' });
    }

    dropdownItemClicked = (pos) => {
        let updatedCurrentTopic = { ...this.state.topicsList[pos] };
        // console.log(updatedCurrentTopic)

        this.setState({ feedbackType: updatedCurrentTopic.type[0] })

        if (updatedCurrentTopic.topicName === 'All Topics') {
            this.setState({ activeTopicPos: pos, currentTopicDetails: updatedCurrentTopic, currentTopicId: updatedCurrentTopic.id, showTableLoader: true, showCardLoader: true, showStudentsTable: false });
            this.props.setNewURL('');
            this.getDailyFeedbackReport();
        } else {
            this.setState({ activeTopicPos: pos, currentTopicDetails: updatedCurrentTopic, currentTopicId: updatedCurrentTopic.id, showTableLoader: true, showCardLoader: true, showStudentsTable: false });
            this.props.setNewURL(updatedCurrentTopic.id);
            this.getDailyFeedbackReportForTopic(updatedCurrentTopic.id);
        }



    }

    getDailyFeedbackReport = () => {

        ResourceAPIController.getInstructorDailyFeedbackReport(this.props.batchCode, this.props.moduleName)
            .then(response => {

                let feedbackId = '';
                if (!IsObjectEmpty(this.props.params) && !IsStringEmpty(this.props.params.feedbackId)) {
                    feedbackId = parseInt(this.props.params.feedbackId, 10);
                }

                const updatedCurrentTopic = response.result.topicsList[0];

                this.setState({
                    showTableLoader: false,
                    showCardLoader: false,
                    topicsList: response.result.topicsList,
                    currentTopicDetails: updatedCurrentTopic,
                    feedbackTopicsList: response.result.feedbacksList
                });


                if (!IsStringEmpty(feedbackId) && feedbackId > 0) {
                    const pos = !IsListEmpty(response.result.topicsList)
                        ? response.result.topicsList.findIndex(topic => topic.id === feedbackId) : 0;

                    this.dropdownItemClicked(pos);
                }

            })
            .catch(err => {
                console.log('getInstructorDailyFeedbackReport error => ', err)
                this.setState({ showTableLoader: false, showCardLoader: false, });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    getDailyFeedbackReportForTopic = (topicId) => {
        ResourceAPIController.getInstructorDailyFeedbackReportForTopic(this.props.batchCode, this.props.moduleName, topicId)
            .then(response => {
                // console.log(response.result)

                if (this.state.feedbackType === "daily") {
                    this.setState({
                        showTableLoader: false,
                        showCardLoader: false,
                        feedbackResponses: response.result.feedbackResponses,
                        clearedDoubts: response.result.clearedDoubts,
                        overallSessionRating: response.result.overallSessionRating,
                        pieChartData: response.result.pieChartData,
                        currentTopicDetails: response.result.currentTopicDetails
                    })
                } else {
                    this.setState({
                        showTableLoader: false,
                        showCardLoader: false,
                        feedbackResponses: response.result.feedbackResponses,
                        clearedDoubts: response.result.clearedDoubts,
                        overallSessionRating: response.result.overallSessionRating,
                        pieChartData: response.result.pieChartData,
                        currentTopicDetails: response.result.currentTopicDetails
                    })
                }
            })
            .catch(err => {
                console.log('getInstructorDailyFeedbackReportForTopic error => ', err)
                this.setState({ showTableLoader: false, showCardLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                else if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
            });
    }


    onViewAllResponsesClicked = () => {
        // console.log("VIEW ALLL RESPONSES CLICKED")
        this.setState({ showStudentsTable: true, showTableLoader: true });
        ResourceAPIController.getDailyFeedbackStudentsListForTopic(this.state.currentTopicId)
            .then(response => {

                this.setState({ showTableLoader: false, studentsList: response.result, fullStudentsList: response.result });

            })
            .catch(err => {
                console.log('getDailyFeedbackStudentsListForTopic error => ', err)
                this.setState({ showTableLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    showStudentResponsePopup = (userId) => {
        // alert('student response => ' + userId);
        this.setState({ showStudentResponsePopup: true, currentUserId: userId });

    }

    closePopup = () => {
        this.setState({ showStudentResponsePopup: false, currentUserId: 0 });
    }

    componentDidMount() {
        const batchCode = this.props.batchCode, moduleName = this.props.moduleName;
        if (!IsStringEmpty(batchCode) && !IsStringEmpty(moduleName)) {
            this.getDailyFeedbackReport(batchCode, moduleName);
        }
        let forProgramManager = GetFromLocalStorage(Constants.KEY_IS_PROGRAM_MANAGER) === 'true' ? true : false;
        this.setState({ isProgramManager: forProgramManager })
    }

    componentDidUpdate(prevProps) {
        const batchCode = this.props.batchCode, moduleName = this.props.moduleName;
        if (prevProps.batchCode !== this.props.batchCode || prevProps.moduleName !== this.props.moduleName) {
            this.getDailyFeedbackReport(batchCode, moduleName);
        }
        if (prevProps.params.feedbackId !== this.props.params.feedbackId && !IsStringEmpty(this.props.params.feedbackId)) {
            this.getDailyFeedbackReportForTopic(this.props.params.feedbackId);
        }
    }


    render() {

        const subtopicsResponses = !IsObjectEmpty(this.state.feedbackResponses) && this.state.feedbackResponses.feedbackAvailable && !IsListEmpty(this.state.feedbackResponses.subtopics)
            ? this.state.feedbackResponses.subtopics.map((subtopic, index) => {
                return (
                    <div className={classes.ProgressItem} key={index}>
                        <span>{subtopic.title}</span>
                        <div className={classes.ProgressDiv}>
                            <ProgressBar styleclass="Rounded" showProgressText={true}
                                progress={subtopic.progressValue}
                                progressValue={subtopic.progressLabel} />
                        </div>
                    </div>
                );
            }) : null;

        const areasOfImprovement = !IsObjectEmpty(this.state.feedbackResponses) && this.state.feedbackResponses.feedbackAvailable && !IsListEmpty(this.state.feedbackResponses.subtopics)
            ? this.state.feedbackResponses.subtopics.map((subtopic, index) => {
                return (
                    <div className={classes.ProgressItem} key={index}>
                        <span>{subtopic.title}</span>
                        <div className={classes.ProgressDiv}>
                            <ProgressBar
                                styleclass="Rounded" showProgressText={true}
                                progress={subtopic.progressValue}
                                progressValue={subtopic.progressLabel} />
                        </div>
                    </div>
                );
            }) : null;

        const feedbackTopicsList = !IsListEmpty(this.state.feedbackTopicsList) ? this.state.feedbackTopicsList.map((session, index) => {

            let completePercentage = session.submission.completelyUnderstood.percentage,
                completeValue = session.submission.completelyUnderstood.value,
                partialPercentage = session.submission.partiallyUnderstood.percentage,
                partialValue = session.submission.partiallyUnderstood.value,
                notUnderstoodPercentage = session.submission.notUnderstood.percentage,
                notUnderstoodValue = session.submission.notUnderstood.value;

            return (
                <tr key={index}>
                    <td>{index + 1}</td>
                    <td className={classes.Link} onClick={() => this.dropdownItemClicked(index + 1)}>{session.topicName}</td>
                    <td className={classes.SubmissionTimeTD}>{session.scheduledDateTime}</td>
                    <td>
                        <div className={classes.MultiProgressBar}>
                            <div className={[classes.ProgressItem, classes.Green,
                            partialPercentage === 0 && notUnderstoodPercentage === 0 ? classes.AllRoundBorder : ''].join(' ')}
                                style={{ width: completePercentage + '%' }}>
                                <p className={classes.Percentage}>
                                    {completePercentage !== 0 ? completePercentage + '%' : ''}
                                </p>
                                <p className={classes.Value}>
                                    {completeValue !== 0 ? completeValue : ''}
                                </p>
                            </div>
                            <div className={[classes.ProgressItem, classes.Yellow,
                            completePercentage === 0 && notUnderstoodPercentage === 0 ? classes.AllRoundBorder
                                : completePercentage === 0 ? classes.LeftRoundBorder
                                    : notUnderstoodPercentage === 0 ? classes.RightRoundBorder : ''].join(' ')}
                                style={{ width: partialPercentage + '%' }}>
                                <p className={classes.Percentage}>
                                    {partialPercentage !== 0
                                        ? partialPercentage + '%' : ''}
                                </p>
                                <p className={classes.Value}>
                                    {partialValue !== 0 ? partialValue : ''}
                                </p>
                            </div>
                            <div className={[classes.ProgressItem, classes.Red,
                            completePercentage === 0 && partialPercentage === 0 ? classes.AllRoundBorder : ''].join(' ')}
                                style={{ width: notUnderstoodPercentage + '%' }}>
                                <p className={classes.Percentage}>
                                    {notUnderstoodPercentage !== 0
                                        ? notUnderstoodPercentage + '%' : ''}
                                </p>
                                <p className={classes.Value}>
                                    {notUnderstoodValue !== 0 ? notUnderstoodValue : ''}
                                </p>
                            </div>
                        </div>
                    </td>
                </tr>
            );
        }) : null;

        const studentsList = !IsListEmpty(this.state.studentsList) ? this.state.studentsList.map((student, index) => {
            return (
                <tr key={index}>
                    <td>{index + 1}</td>
                    <td className={classes.Link} onClick={() => this.showStudentResponsePopup(student.userId)}>{student.name}</td>
                    <td className={classes.SubmissionTimeTD}>{student.submissionTime}</td>
                    <td className={[classes.Link, classes.CenterAlign].join(' ')} onClick={() => this.showStudentResponsePopup(student.userId)}>Feedback</td>
                </tr>
            );
        }) : null;

        return (
            <div className={classes.DailyFeedbackSectionContainer}>

                {
                    this.state.showStudentResponsePopup
                        ? <StudentResponsePopup
                            show={this.state.showStudentResponsePopup}
                            topicId={this.state.currentTopicId}
                            userId={this.state.currentUserId}
                            closePopup={this.closePopup}
                        />
                        : null
                }
                <h2 className={classes.ReportHeading}>
                    {
                        this.props.forPMPage === true ? 'Session Feedback' : 'Daily Feedback Report'
                    }
                </h2>

                <DailyFeedbackDropdown
                    forWeekly={false}
                    dropdownItemsList={this.state.topicsList}
                    activeItemPos={this.state.activeTopicPos}
                    dropdownItemClicked={this.dropdownItemClicked}
                />

                <hr className={classes.Divider} />

                <div className={classes.ReportSection}>
                    <h3 className={classes.ReportSubHeading}>Report: {this.state.currentTopicDetails.topicName}</h3>
                    <p className={classes.DateText}>{this.state.currentTopicDetails.date}</p>

                    {
                        !this.state.showStudentsTable
                            ? this.state.activeTopicPos === 0
                                ? <div>

                                    <div className={[classes.Legend, classes.FeedbackTypes].join(' ')}>
                                        <p><span className={classes.Green}></span>Completely Understood</p>
                                        <p><span className={classes.Yellow}></span>Partially Understood</p>
                                        <p><span className={classes.Red}></span>Did not Understand</p>
                                    </div>

                                    <table className={classes.Table}>
                                        <thead className={classes.TableHeadings}>
                                            <tr>
                                                <th className={classes.SrNo}>Sr.No.</th>
                                                <th className={classes.TopicNameTH}>TOPIC NAME</th>
                                                <th className={classes.SessionDateTH}>SESSION DATE</th>
                                                <th className={classes.UnderstoodTH}>UNDERSTOOD BY STUDENTS</th>
                                            </tr>
                                        </thead>
                                        <tbody className={classes.TableBody}>

                                            {this.state.showTableLoader
                                                ? <tr>
                                                    <td colSpan="4" className={classes.AlignCenter}>
                                                        <ShowMiniLoader isLoading={true} transparentBg={true} />
                                                    </td>
                                                </tr>
                                                : !IsListEmpty(feedbackTopicsList)
                                                    ? feedbackTopicsList
                                                    : <tr>
                                                        <td colSpan="4" className={classes.AlignCenter}>Data Not Available!</td>
                                                    </tr>}

                                        </tbody>
                                    </table>
                                </div>
                                : this.state.feedbackType === "daily" ?
                                    <DailyFeedbackReportCard
                                        subtopicsResponses={subtopicsResponses}
                                        showCardLoader={this.state.showCardLoader}
                                        feedbackType={this.state.feedbackType}
                                        isProgramManager={this.state.isProgramManager}
                                        currentTopicDetails={this.state.currentTopicDetails}
                                        clearedDoubts={this.state.clearedDoubts}
                                        overallSessionRating={this.state.overallSessionRating}
                                        feedbackResponses={this.state.feedbackResponses}
                                        pieChartData={this.state.pieChartData}
                                        studentsList={this.state.studentsList}
                                        fullStudentsList={this.state.fullStudentsList}
                                        onViewAllResponsesClicked={this.onViewAllResponsesClicked} /> :
                                    <DailyFeedbackReportCard
                                        areasOfImprovement={areasOfImprovement}
                                        showCardLoader={this.state.showCardLoader}
                                        feedbackType={this.state.feedbackType}
                                        isProgramManager={this.state.isProgramManager}
                                        currentTopicDetails={this.state.currentTopicDetails}
                                        clearedDoubts={this.state.clearedDoubts}
                                        overallSessionRating={this.state.overallSessionRating}
                                        feedbackResponses={this.state.feedbackResponses}
                                        pieChartData={this.state.pieChartData}
                                        onViewAllResponsesClicked={this.onViewAllResponsesClicked}
                                    />

                            : <div>
                                <table className={classes.Table}>
                                    <thead className={classes.TableHeadings}>
                                        <tr>
                                            <th className={classes.SrNo}>Sr.No.</th>
                                            <th className={classes.StudentNameTH}>
                                                <div className={classes.CenterAlignTh}>
                                                    STUDENT NAME
                                                    <img src={FilterIcon} onClick={this.onNameFilterClicked} alt={'Student Name filter sort icon'} className={classes.FilterIcon} />
                                                    {this.state.showNameFilterDropdown
                                                        ? <div className={classes.Dropdown}>
                                                            <FilterDropDown
                                                                itemList={this.state.nameFilterItems}
                                                                onDropDownClicked={this.onNameFilterClicked}
                                                                onDropDownItemClicked={this.onDropDownItemClicked}
                                                                activeItem={this.state.activeNameFilterDropDownItem}
                                                                searchFieldValue={this.state.nameSearchFieldValue}
                                                                inputChangeHandler={this.nameSearchInputChangeHandler}
                                                                onSearchIconClick={this.onNameSearchIconClick}
                                                                clearSearchResults={this.clearSearchResults}
                                                                searchString={this.state.nameSearchFieldValue}
                                                                forNumber={false}
                                                            />
                                                        </div>
                                                        : null}
                                                </div>
                                            </th>
                                            <th className={classes.SubmissionTimeTH}>SUBMISSION TIME</th>
                                            <th className={classes.ResponseLinkTH}>RESPONSE LINK</th>
                                        </tr>
                                    </thead>
                                    <tbody className={[classes.TableBody, classes.StudentsTable].join(' ')}>

                                        {this.state.showTableLoader
                                            ? <tr>
                                                <td colSpan="4" className={classes.AlignCenter}>
                                                    <ShowMiniLoader isLoading={true} transparentBg={true} />
                                                </td>
                                            </tr>
                                            : !IsListEmpty(studentsList)
                                                ? studentsList
                                                : <tr>
                                                    <td colSpan="4" className={classes.AlignCenter}>Data Not Available!</td>
                                                </tr>}

                                    </tbody>
                                </table>
                            </div>
                    }

                </div>

            </div>
        );
    }
}

export default DailyFeedbackSection;